import { z } from 'zod';
import { BinScatterMultiSelectRequest } from 'libs/end-to-end/src/custom-viz/BinScatterMultiSelectTypes';
import { BinScatterCrossSelectRequest } from 'libs/end-to-end/src/custom-viz/BinScatterCrossSelectTypes';
import { PipelineAnalysisRequest } from 'libs/end-to-end/src/custom-viz/PipelineAnalysisTypes';
import { BiasAnalysisRequest } from 'libs/end-to-end/src/custom-viz/BiasAnalysisTypes';
import { HiringCopilotRequest } from 'libs/end-to-end/src/custom-viz/HiringCopilotTypes';
import { PromotionCopilotRequest } from 'libs/end-to-end/src/custom-viz/PromotionCopilotTypes';
import { PayBenchmarkingRequest } from 'libs/end-to-end/src/custom-viz/PayBenchmarkingTypes';
import { PayCorrectionRequest } from 'libs/end-to-end/src/custom-viz/PayCorrectionTypes';
import { SuccessPhenotypeV2Request } from 'libs/end-to-end/src/custom-viz/SuccessPhenotypeTypes';
import { TopLevelAnalysisRequest } from 'libs/end-to-end/src/custom-viz/TopLevelAnalysisTypes';
import { ProgressRequest } from 'libs/end-to-end/src/custom-viz/ProgressTypes';
import { HeatmapAnalysisRequest } from 'libs/end-to-end/src/custom-viz/HeatmapAnalysisTypes';
import { NlpGraphRequest } from 'libs/end-to-end/src/custom-viz/NlpGraphTypes';
import { TableViewRequest } from 'libs/end-to-end/src/custom-viz/TableViewTypes';
import { TimeSeriesTrendsRequest } from 'libs/end-to-end/src/custom-viz/TimeSeriesTrendsTypes';
import { SummaryStatsRequest } from 'libs/end-to-end/src/summary-stats';
import { RichTextRequest } from 'libs/end-to-end/src/custom-viz/RichTextTypes';
import { GeolocationRequest } from 'libs/end-to-end/src/custom-viz/GeolocationTypes';
import { StreamlitCustomVizRequest } from 'libs/end-to-end/src/custom-viz/StreamlitCustomVizTypes';

export const CustomVizRequest = z.union([
  BinScatterMultiSelectRequest,
  BinScatterCrossSelectRequest,
  PipelineAnalysisRequest,
  BiasAnalysisRequest,
  HiringCopilotRequest,
  PromotionCopilotRequest,
  PayBenchmarkingRequest,
  PayCorrectionRequest,
  SuccessPhenotypeV2Request,
  TopLevelAnalysisRequest,
  ProgressRequest,
  HeatmapAnalysisRequest,
  NlpGraphRequest,
  TableViewRequest,
  TimeSeriesTrendsRequest,
  SummaryStatsRequest,
  RichTextRequest,
  GeolocationRequest,
  StreamlitCustomVizRequest,
]);

export type CustomVizRequest = z.infer<typeof CustomVizRequest>;
